import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from "rxjs";

const daysOfWeek: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

@Component({
  selector: 'om-day-picker',
  templateUrl: './om-day-picker.component.html',
  styleUrls: []
})
export class OmDayPickerComponent implements OnInit {

  @Input() control: FormControl = new FormControl();
  @Input() label: string;
  @Input() required: boolean = false;
  @Input() useTooltip: boolean = false;
  @Input() readonly: boolean = false;

  _options$: BehaviorSubject<{ value: number, label: string }[]> = new BehaviorSubject<{
    value: number,
    label: string
  }[]>(null);
  selected: Set<number> = new Set();

  constructor(private _translateService: TranslateService) {
  }

  ngOnInit(): void {
    this._options$.next(daysOfWeek.map(value => {
      const label: string = this._translateService.instant('SETTINGS.CALENDARS_SETTINGS.WEEKDAYS.' + value.toUpperCase());
      return {value: daysOfWeek.indexOf(value), label: label};
    }));

    this.selected = new Set(this.control?.value ?? []);
  }

  _selectItem(event: Event, value: number): void {
    event.preventDefault();
    if (this.readonly) {
      return;
    }
    if (this.selected.has(value)) {
      this.selected.delete(value);
    } else {
      this.selected.add(value);
    }
    this.control.patchValue([...this.selected].sort((a, b) => a-b));
    this.control.markAllAsTouched();
    this.control.markAsDirty();
  }

  _trackByValue(value: number, index: number): number {
    return value;
  }
}
